import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SelectionId } from 'src_common/common/websocket2/id/WebsocketId';
import { PlaceOnlyRaceSummaryRowHeader } from './PlaceOnlySummary.style';
import { LazyImageSilk } from 'src/domains/sportsbook/webview/components/lazyImage/LazyImageSilk';
import {
    CellRunner,
    JockeyAndTrainerDetailsBox,
    SilkCellWrapper,
} from 'src/domains/sportsbook/webview/components/raceSummary/raceSummarySport/placeOnlySummary/RaceSummaryRowPlaceOnly.style';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface PropsType {
    isNonRunner?: boolean;
    selectionId: SelectionId;
}

export const RaceSummaryRowPlaceOnly = observer('RaceSummaryRowPlaceOnly', (props: PropsType) => {
    const { selectionId, isNonRunner } = props;

    const common = useCommon();
    const configState = ConfigComponents.get(common).config;

    const selectionModel = selectionId.getModel();
    if (selectionModel === null) {
        return null;
    }

    const marketModel = selectionModel.getMarket();
    if (marketModel === null) {
        return null;
    }

    const eventModel = marketModel.getEvent();
    if (eventModel === null) {
        return null;
    }

    const silkUrl = selectionModel.metaDataSilkUrl ?? '';
    const silkAltDesc = selectionModel.metaDataSilk ?? 'Silk image';

    return (
        <PlaceOnlyRaceSummaryRowHeader
            isNonRunner={isNonRunner}
            variant={configState.componentVariants.sportsbookVariant}
        >
            <CellRunner>
                <SilkCellWrapper>
                    <LazyImageSilk
                        imgBase={{
                            src: silkUrl,
                            optimizeOptions: {
                                quality: 85,
                                width: 54,
                            },
                        }}
                        alt={silkAltDesc}
                    />
                </SilkCellWrapper>

                <JockeyAndTrainerDetailsBox
                    selectionId={selectionId}
                    isDetailsAvailable={true}
                />
            </CellRunner>
        </PlaceOnlyRaceSummaryRowHeader>
    );
});
